import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDotGrid2x3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconDotGrid2x3"><Path d="M7 3V7H11V3H7Z" fill="currentColor"/><Path d="M13 3V7H17V3H13Z" fill="currentColor"/><Path d="M7 10V14H11V10H7Z" fill="currentColor"/><Path d="M13 10V14H17V10H13Z" fill="currentColor"/><Path d="M7 17V21H11V17H7Z" fill="currentColor"/><Path d="M13 17V21H17V17H13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDotGrid2x3;
